<template>
  <div class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" id="emailTemplateModal">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header header-dark">
          <h5 class="modal-title">{{ template.title }}</h5>
        </div>
        <div class="modal-body p-0">
          <div id="summernote"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">Close</button>
          <button type="button" class="btn btn-success" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueSelect from 'vue-select'
// import Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'

// import clientStore from '@/stores/clients'
import emailTemplate from '@/libs/email-template'
// import auth from '@/libs/auth'

// import api from '@/api'
// import productStore from '@/stores/products'
// import n from '@/libs/notifications'

import $ from 'jquery'
import "summernote/dist/summernote-bs4.css"
import "summernote"

export default {
  name: 'email-template-modal',

  props: ['template'],

  components: {
    // VueSelect,
    // Dropzone 
  },

  data() {
    return {
      
    }
  },

  methods: {
    save() {
      const template = this.template
      template.body  = $('#summernote').summernote('code')
      emailTemplate.save(template).then(() => {
        $('#emailTemplateModal').modal('hide')
        this.$emit('closed')
      })
    },

    close() {
      $('#emailTemplateModal').modal('hide')
      this.$emit('closed')
    }
  },

  watch: {
    template() {
      if(this.template.id) {
        $('#emailTemplateModal').modal('show')
        $('#summernote').summernote('code', this.template.body)  
      } else {
        $('#emailTemplateModal').modal('hide')
      }
    }
  }
}
</script>

<style scoped>
.modal-body {
  max-height: calc(90vh - 200px);
  overflow-y: auto;
}
</style>